import { render } from "./long-insure-bill.vue?vue&type=template&id=57d23f6a&scoped=true&ts=true"
import script from "./long-insure-bill.vue?vue&type=script&lang=ts"
export * from "./long-insure-bill.vue?vue&type=script&lang=ts"

import "./long-insure-bill.vue?vue&type=style&index=0&id=57d23f6a&lang=stylus&scoped=true"

import exportComponent from "E:\\code\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57d23f6a"]])

export default __exports__